import {
	Container,
	ContainerPadding,
	CTA,
	styled,
	Text,
	ThemeProvider,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { COLOR_TOKEN } from 'src/components/color-token';
import {
	Filtros,
	NewMap,
	useMapGeneralController,
	useOneFormContext,
} from 'src/feature-app';
import { Close, List, Locate } from 'src/icons-core-imports';
import {
	CarouselWidget,
	CTAMapa,
	CTAServices,
	ViewWidgetMapaProps,
} from 'src/widgets';

//Mobile styled components

const Wrapper = styled.div`
	display: flex;
	position: relative;
`;

const WrapperCTAMapa = styled.div`
	z-index: 20;
	width: 100%;
	padding-top: 12px;
	position: absolute;

	& button {
		background-color: ${COLOR_TOKEN.main.background.tertiary};
	}
`;

const FilterMobileNavbar = styled.div`
	position: relative;
	top: 0;
	width: 100vw;
	padding: 0px 20px;
	z-index: 20;
	background-color: ${COLOR_TOKEN.main.background.tertiary};
	display: flex;
	justify-content: space-between;
`;

interface VerMasYCarouselPositionProps {
	translateCarousel: boolean;
	userIsGeoLocated: boolean;
}

const VerMasYCarouselPosition = styled.div<VerMasYCarouselPositionProps>`
	position: absolute;
	bottom: 38px;
	height: ${props => (props.userIsGeoLocated ? '216px' : '160px')};
	width: 100%;
	transform: ${props =>
		props.translateCarousel ? 'translateY(116px)' : null};
	@media all and (min-width: 560px) {
		height: ${props => (props.userIsGeoLocated ? '244px' : '184px')};
	}
`;
const SoloCardWrapper = styled.div`
	background-color: ${COLOR_TOKEN.main.background.tertiary};
	bottom: 8px;
	height: fit-content;
	position: absolute;
	margin: 0 var(--size-grid002);
	width: var(--size-grid020);

	.box-card-wrapper {
		border: none;
		margin-top: 0;
	}
`;
const CTASwrapper = styled.div`
	padding-right: 20px;
	padding-bottom: 12px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
`;
const VerMasTalleresCTA = styled.div`
	height: 32px;
	padding-right: 16px;
	padding-left: 16px;
	background-color: ${COLOR_TOKEN.main.background.tertiary};
	border: 1px solid ${COLOR_TOKEN.main.content.primary};
	border-radius: 500px;
	color: ${COLOR_TOKEN.main.content.primary};
	display: flex;
	align-items: center;
	gap: 4px;
`;
const ControllerBackground = styled.div`
	border-radius: 100%;
	background-color: ${COLOR_TOKEN.main.background.tertiary};
	height: 44px;
	width: 44px;
	margin-bottom: 12px;
	button {
		border: 1px solid ${COLOR_TOKEN.main.content.primary};
	}
`;

interface CloseButtonProps {
	isTabsClose?: boolean;
}
const CloseButtonWrapper = styled.div<CloseButtonProps>`
	position: absolute;
	padding-bottom: ${props => (props.isTabsClose ? '12px' : null)};
	background-color: ${COLOR_TOKEN.main.background.tertiary};
	width: 100%;
	padding-top: 12px;
	padding-left: 12px;
	z-index: 4;
	@media screen and (min-width: 560px) {
		left: 20px;
	}
	button {
		color: ${props =>
			props.isTabsClose ? COLOR_TOKEN.main.content.primary : null};
	}
`;

export const ViewMobileWidgetMapa = (props: ViewWidgetMapaProps) => {
	const {
		handleSeleccionarOnClick,
		renderPoints,
		pointsToList,
		CTAServicesProps,
		CTAMapaProps,
	} = props;
	const { carPickupSelected, replacementCarSelected } = CTAServicesProps;

	const { handlePreviousStep } = useOneFormContext();

	const { centerInGeoLocatedCenter, userIsGeoLocated, searchIsDealer } =
		useMapGeneralController();

	//controladores de vista

	const [showFiltros, setShowFiltros] = useState<boolean>(false);
	const [showTalleres, setShowTalleres] = useState<boolean>(false);
	const [showMap, setShowMap] = useState<boolean>(true);
	const [translateCarousel, setTranselateCarousel] = useState<boolean>(false);

	//otros
	const [gelocalizationActive, setGelocalizationActive] =
		useState<boolean>(false);

	useEffect(() => {
		if (userIsGeoLocated) {
			setGelocalizationActive(true);
		}
	}, [userIsGeoLocated]);

	const handleShowFiltros = () => {
		setShowFiltros(!showFiltros);
		setShowTalleres(false);
	};
	const handleShowTalleres = () => {
		setShowTalleres(!showTalleres);
		setShowFiltros(false);
	};

	useEffect(() => {
		if (showFiltros === false && showTalleres === false) {
			setShowMap(true);
		} else {
			setShowMap(false);
		}
	}, [showFiltros, showTalleres]);

	return (
		<div className="mobile-map-wrapper">
			{showMap ? (
				<>
					<ThemeProvider theme="main">
						<FilterMobileNavbar
							className="filtros-navbar"
							onClick={e => {
								e.preventDefault();
								setTranselateCarousel(false);
							}}
							onTouchStart={e => {
								setTranselateCarousel(false);
							}}
						>
							<CTAServices {...CTAServicesProps} />
						</FilterMobileNavbar>
					</ThemeProvider>
					<Wrapper>
						<WrapperCTAMapa>
							<CTAMapa {...CTAMapaProps} />
						</WrapperCTAMapa>
						<div
							style={{
								height: '100%',
								backgroundColor: 'grey',
								position: 'relative',
								top: '0',
								width: '100%',
							}}
						>
							<NewMap
								searchIsDealer={searchIsDealer}
								setTranslateCarousel={setTranselateCarousel}
								translateCarousel={translateCarousel}
								carPickupSelected={carPickupSelected}
								replacementCarSelected={replacementCarSelected}
								isWidget
							/>
						</div>
					</Wrapper>

					{pointsToList ? (
						searchIsDealer ? (
							<SoloCardWrapper>
								{renderPoints(
									pointsToList,
									carPickupSelected,
									replacementCarSelected,
									true,
								)}
							</SoloCardWrapper>
						) : (
							<VerMasYCarouselPosition
								className="ver-mas-carousel-position"
								translateCarousel={translateCarousel}
								onClick={e => {
									e.preventDefault();
									setTranselateCarousel(false);
								}}
								onTouchStart={e => {
									e.preventDefault();
									setTranselateCarousel(false);
								}}
								userIsGeoLocated={userIsGeoLocated}
							>
								<ThemeProvider theme="main">
									<CTASwrapper>
										{gelocalizationActive ? (
											<ControllerBackground
												onTouchStart={e => {
													e.preventDefault();
													centerInGeoLocatedCenter();
													e.stopPropagation();
												}}
											>
												<CTA
													tag="button"
													emphasis="secondary"
													onClick={e => {
														e.preventDefault();
														centerInGeoLocatedCenter();
														e.stopPropagation();
													}}
													aria-label="Localizar"
													icon={
														<Locate variant="small" />
													}
												/>
											</ControllerBackground>
										) : null}
										<VerMasTalleresCTA
											onTouchStart={e => {
												e.preventDefault();
												e.stopPropagation();
											}}
											onClick={e => {
												e.preventDefault();
												e.stopPropagation();
												handleShowTalleres();
												setTranselateCarousel(false);
											}}
										>
											<List />
											<Text
												appearance={
													TokenTextAppearance.label150
												}
												staticSize
											>
												Ver lista
											</Text>
										</VerMasTalleresCTA>
									</CTASwrapper>
								</ThemeProvider>

								{/* Aunque en principio no debería devolver nunca sólo un resultado, dejo el siguiente
                  render condicional por is acaso */}
								{pointsToList.length === 1 ? (
									<SoloCardWrapper>
										{renderPoints(
											pointsToList,
											carPickupSelected,
											replacementCarSelected,
											true,
										)}
									</SoloCardWrapper>
								) : (
									<CarouselWidget
										carPickupSelected={carPickupSelected}
										replacementCarSelected={
											replacementCarSelected
										}
										handleSeleccionarOnClick={
											handleSeleccionarOnClick
										}
										pointsToList={pointsToList}
									/>
								)}
							</VerMasYCarouselPosition>
						)
					) : null}
				</>
			) : (
				<>
					{showTalleres ? (
						<div
							style={{
								height: '100%',
								minHeight: '100vh',
								width: '100%',
								backgroundColor:
									COLOR_TOKEN.main.background.tertiary,
							}}
						>
							<CloseButtonWrapper isTabsClose={true}>
								<CTA
									tag="button"
									emphasis="tertiary"
									size="small"
									onClick={(e: any) => {
										e.preventDefault();
										handleShowTalleres();
									}}
									aria-label="Cerrar"
									icon={<Close />}
								/>
							</CloseButtonWrapper>
							<Container
								padding={{
									bottom: ContainerPadding.static500,
									top: ContainerPadding.static520,
									right: ContainerPadding.static300,
									left: ContainerPadding.static300,
								}}
								horizontalAlign={'center'}
								stretchContent
								wrap={'always'}
							>
								<CTAServices {...CTAServicesProps} />

								{renderPoints(
									pointsToList,
									carPickupSelected,
									replacementCarSelected,
									false,
								)}
							</Container>
						</div>
					) : showFiltros ? (
						<ThemeProvider theme="main">
							<div
								style={{
									minHeight: '100vh',
									height: '100%',
									width: '100%',
									backgroundColor:
										' ${COLOR_TOKEN.main.background.tertiary}',
								}}
								className="filtros-wrapper"
							>
								<CloseButtonWrapper
									style={{ paddingBottom: '12px' }}
								>
									<CTA
										tag="button"
										emphasis="tertiary"
										size="small"
										onClick={(e: any) => {
											e.preventDefault();
											handleShowFiltros();
										}}
										aria-label="Cerrar"
										icon={<Close />}
									/>
								</CloseButtonWrapper>
								<Filtros
									closeFiltros={() => handleShowFiltros()}
									showFiltros={showFiltros}
									setShowFiltros={setShowFiltros}
									onlySuggest={true}
									concesionario={true}
								/>
							</div>
						</ThemeProvider>
					) : null}
				</>
			)}
		</div>
	);
};
